<template>
  <div v-if="type == 'individual'" class="sf-account-kind-banner">
    <div>
      <h3>Individual subscription</h3>
      <AccountShortDescription type="individual" class="tw-text-mainbg1" />
      <div class="tw-text-center tw-mt-8">
        <button @click="onRegister" class="sf-btn-primary tw-mx-2">
          Purchase
        </button>
      </div>
    </div>
  </div>
  <div v-else-if="type == 'school'" class="sf-account-kind-banner">
    <div>
      <h3>School subscription</h3>
      <AccountShortDescription type="school" class="tw-text-mainbg1" />
      <div class="tw-text-center tw-mt-8">
        <button @click="onRegister" class="sf-btn-primary tw-mx-2">
          Purchase
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped lang="postcss">
.sf-account-kind-banner {
  @apply tw-relative tw-top-0 tw-left-0 tw-bg-color2 tw-rounded-xl tw-p-4 tw-mb-4 
    md:tw-rounded-3xl md:tw-p-10;
}

.sf-account-kind-banner h3 {
  @apply tw-my-6 tw-text-mainbg1 tw-font-bold;
}

.sf-account-kind-banner a {
  @apply tw-no-underline;
}
</style>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import AccountShortDescription from "./AccountShortDescription.vue";
import { SfAccountType } from "@/types/generalTypes";
import { storeProducts } from "@/state/productsState";

export default defineComponent({
  components: { AccountShortDescription },
  props: {
    type: { type: String as PropType<SfAccountType>, required: true },
  },
  data() {
    return {};
  },
  computed: {
    storeProducts() {
      return storeProducts.value;
    },
    individualCost() {
      if (!this.storeProducts) {
        return "";
      }
      return this.storeProducts["individualSpelling"]?.cost;
    },
    schoolCost() {
      if (!this.storeProducts) {
        return "";
      }
      return this.storeProducts["classSpelling"]?.cost;
    },
  },
  methods: {
    onRegister() {
      const url =
        this.type == "school" ? "/register/school" : "/register/individual";
      this.$router.push(url);
    },
  },
});
</script>
